<template>
  <b-modal
    id="ip-previewmodal"
    centered
    hide-footer
    hide-header
    :visible="ipmodal"
    no-close-on-backdrop
    @hidden="closeModal"
  >
    <div class="d-flex align-items-center justify-content-between m-3">
      <div class="teams-modal-head">Preview Feedback Form</div>
      <div @click="closeModal">
        <img
          src="../../assets/New-imgs/teams-icons/teams-close-icon.svg"
          alt=""
          class="pointer rotate-on-hover"
        />
      </div>
    </div>
    <hr class="mb-0" />
    <div class="p-3">
      <div
        class="newInt-preview-modalhead text-truncate"
        v-if="selectedRound.name"
      >
        {{ selectedRound.name | accesscontrolrolesdesc }}
      </div>
      <div
        class="newInt-preview-container pr-1"
        :style="
          feedbackByRec ||
          (allData.automatic && 'max-height: calc(100vh - 275px) !important;')
        "
      >
        <div class="p-3">
          <div class="newInt-preview-container-head">Basic Info</div>

          <div class="mt-3 d-flex align-items-center">
            <div class="newInt-preview-inputHead" style="width: 40%">
              Candidate Name
            </div>

            <div style="width: 60%">
              <b-form-input
                class="newInt-preview-inputField w-100"
                v-model="basicCandInfo.name"
                disabled
              >
              </b-form-input>
            </div>
          </div>

          <div class="mt-3 d-flex align-items-center">
            <div class="newInt-preview-inputHead" style="width: 40%">
              Evaluation Date
            </div>

            <div style="width: 60%">
              <b-form-input
                class="newInt-preview-inputField w-100"
                v-model="evaluationDate"
                disabled
              >
              </b-form-input>
            </div>
          </div>

          <div class="mt-3 d-flex align-items-center">
            <div class="newInt-preview-inputHead" style="width: 40%">
              {{
                allData.feedBackForm.recommendation == "NI"
                  ? "Recruiter"
                  : "Panel Name"
              }}
            </div>

            <div style="width: 60%">
              <b-form-input
                class="newInt-preview-inputField w-100"
                placeholder="-"
                v-model="basicCandInfo.panel"
                disabled
              >
              </b-form-input>
            </div>
          </div>
          <div class="mt-3 d-flex align-items-center">
            <div class="newInt-preview-inputHead" style="width: 40%">
              Mode Of Interview
            </div>

            <div style="width: 60%">
              <b-form-input
                class="newInt-preview-inputField w-100"
                v-model="modeOfInteriew"
                disabled
              >
              </b-form-input>
            </div>
          </div>
          <div
            class="mt-3 d-flex align-items-center"
            v-if="allData.feedBackForm.recommendation"
          >
            <div class="newInt-preview-inputHead" style="width: 40%">
              Action
            </div>

            <div style="width: 60%">
              <b-form-input
                class="newInt-preview-inputField w-100"
                v-model="candidateAction"
                disabled
              >
              </b-form-input>
            </div>
          </div>
          <div
            class="mt-3 d-flex align-items-center"
            v-if="allData.feedBackForm.recruiterRemarks"
          >
            <div class="newInt-preview-inputHead" style="width: 40%">
              Remarks
            </div>

            <div
              style="width: 60%"
              v-b-popover.hover.bottom="allData.feedBackForm.recruiterRemarks"
            >
              <b-form-input
                class="newInt-preview-inputField w-100"
                v-model="allData.feedBackForm.recruiterRemarks"
                disabled
              >
              </b-form-input>
            </div>
          </div>
          <div v-if="feedbackByRec || allData.automatic" class="d-flex">
            <div style="width: 40%"></div>
            <div style="width: 60%">
              <img src="@/assets/img/newkanban/small-info.svg" />
              <span
                class="ml-1 priority-labels"
                v-if="
                  (allData.automatic || filledByHire3xPanel) && !feedbackByRec
                "
                >Feedback given by
                {{
                  filledByHire3xPanel
                    ? "Hire3x Panelist"
                    : "Hire3x Assessment System"
                }}</span
              >
              <template v-else>
                <span class="priority-labels">
                  This form is filled by {{ userType }} </span
                ><span class="mob-bold-txt-2">"{{ recruiterName }}"</span>
              </template>
            </div>
          </div>
        </div>
        <template
          v-if="
            basicCandInfo.modeOfInterview === 'assesment' &&
            allData.assessmentResponse &&
            allData.assessmentResponse.status === 2 &&
            allData.assessmentResponse.evaluationStatus
          "
        >
          <div class="my-2 newJD-int-container p-0">
            <div
              class="
                newJD-int-container-selected
                pointer
                d-flex
                align-items-center
                justify-content-between
              "
            >
              <div class="newJD-int-mainhead">Assessment</div>
              <div
                v-if="cheatingProbability || cheatingProbability == 0"
                class="
                  kanban-ac-header-bluetxt
                  d-flex
                  align-items-center
                  gap-10
                "
              >
                Cheating Probability (%) :
                <div class="fs-12 fw-500" :class="getColor('color')">
                  {{ cheatingProbability }}%
                </div>
                <div
                  v-if="showCheatingText"
                  class="metric-spoken-tag fs-11 fw-400 font-inter"
                  :class="getColor('bg')"
                >
                  {{ getCheatingText }}
                </div>
              </div>
            </div>
            <div class="p-3">
              <div class="d-flex align-items-center justify-content-between">
                <div class="newCand-viewFdbck-font">
                  Total Marks :
                  {{ allData.assessmentResponse.marks.marksScored }}/{{
                    allData.assessmentResponse.marks.totalMarks
                  }}
                </div>
                <div class="newCand-viewFdbck-font">
                  Passing Percentage (%) :
                  {{
                    allData.assessmentResponse.passingStatus.passingPercentage
                  }}/100
                </div>
              </div>

              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  mt-2
                  w-100
                "
              >
                <div style="width: 90%">
                  <div class="newCand-viewFdbck-head">Sections</div>
                  <div
                    v-for="(section, index) in allData.assessmentResponse.marks
                      .sectionMarks"
                    :key="index"
                    class="mt-2 newCand-viewFdbck-subhead"
                  >
                    {{ section.sectionName }}
                  </div>
                </div>
                <div style="width: 10%">
                  <div class="newCand-viewFdbck-head">Marks</div>
                  <div
                    v-for="(section, index) in allData.assessmentResponse.marks
                      .sectionMarks"
                    :key="index"
                    class="mt-2 newCand-viewFdbck-font"
                  >
                    {{ section.sectionMarksScored }}/{{
                      section.sectionMarksTotal
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div
          class="d-flex p-3 download-bckg justify-content-between"
          v-if="allData.feedBackForm.panelFeedbackForm"
        >
          <div class="w-90 d-flex text-truncate">
            <img
              src="../../assets/img/newkanban/file-icon.svg"
              alt=""
              class="mr-2"
            />
            <div>
              {{ fileName }}
            </div>
          </div>
          <img
            v-b-tooltip.hover.bottom="'Download Feedback Form'"
            @click="downloadFeedback(allData.feedBackForm.panelFeedbackForm)"
            alt=""
            class="mr-2 pointer"
            src="../../assets/panelLog/download_fdfm.svg"
          />
        </div>
        <div v-if="selectedRound.skills && selectedRound.skills.length != 0">
          <div
            class="mt-3 newInt-inner-containers"
            v-for="(input, k) in selectedRound.skills"
            :key="k"
          >
            <div :style="input.name.length > 30 ? 'width: 70%' : ''">
              <div class="newInt-inner-containers-head mb-2 text-truncate">
                {{ input.name }} &nbsp;<span
                  v-if="input.mandatory == true"
                  class="asterik"
                  >*</span
                >
              </div>

              <div class="mt-2 d-flex" v-if="input.markingType == 'rating'">
                <div class="mt-2 newInt-inner-containers-subhead">Rating</div>
                <div>
                  <b-form-rating
                    variant="primary"
                    v-model="input.mark"
                    class="mb-2 newInt-rating p-0 w-25 ml-2"
                    disabled
                  ></b-form-rating>
                </div>
              </div>

              <div v-if="input.markingType == 'score'">
                <div class="topDiv d-flex align-items-center">
                  <div>
                    <label class="newInt-inner-containers-subhead">Score</label>
                  </div>
                  <div class="ml-2">
                    <b-form-input
                      class="newInt-previewInputField-score no-spinner"
                      v-model="input.mark"
                      disabled
                      type="number"
                    >
                    </b-form-input>
                  </div>
                  <div class="ml-2 newInt-preview-container-subFont">
                    Out of 10
                  </div>
                </div>
              </div>
              <div class="mt-2" v-if="input.commentMode == true">
                <div class="topDiv">
                  <div>
                    <label class="newInt-inner-containers-subhead"
                      >Comments</label
                    >
                  </div>
                  <div class="mt-1">
                    <b-form-textarea
                      class="newInt-previewInputField"
                      v-model="input.comments"
                      placeholder="Comments will be shown here"
                      disabled
                      rows="3"
                      max-rows="4"
                    >
                    </b-form-textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="mb-1 mt-3 newInt-inner-containers"
          v-if="showScreenshot && allData.feedBackForm.candidateImage"
        >
          <div class="d-flex align-items-center">
            <div>
              <img
                src="../../assets/New-imgs/interviewProcess-icons/newInt-cand-screenshot.svg"
                alt=""
              />
            </div>
            <div class="newInt-sc-font ml-3">Candidate Screenshot</div>
          </div>

          <div
            class="
              mt-3
              newInt-previewNoImageInputField-sc
              d-flex
              align-items-center
              justify-content-center
            "
          >
            <div class="sc-font" v-if="allData.feedBackForm.candidateImage">
              <img
                class="h-100 w-100"
                :src="allData.feedBackForm.candidateImage"
                alt="Candidate Image"
              />
            </div>
          </div>
        </div>
        <div
          class="mt-3 newInt-inner-containers"
          v-else-if="
            ($route.name == 'CreateInterviewProcess' ||
              $route.name == 'EditInterviewProcess' ||
              $route.name == 'ActivateInterview') &&
            selectedRound.screenshot
          "
        >
          <div class="mt-3 newInt-inner-containers ml-1 mr-1">
            <div class="d-flex align-items-center">
              <div>
                <img
                  src="../../assets/New-imgs/interviewProcess-icons/newInt-cand-screenshot.svg"
                  alt=""
                />
              </div>
              <div class="newInt-sc-font ml-2">Candidate Screenshot</div>
            </div>

            <div
              class="
                mt-3
                newInt-previewInputField-sc
                d-flex
                align-items-center
                justify-content-center
              "
            >
              <div class="sc-font" v-if="selectedRound.screenshot">
                Screenshot will be shown here
              </div>
              <!-- <div class="sc-font" v-else>No Screenshot Required</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="my-0" />
    <div
      class="d-flex align-items-center p-2 bluebtn mt-2 mb-2"
      :class="
        showBotAnalysis ? 'justify-content-between' : 'justify-content-end'
      "
    >
      <div
        v-if="showBotAnalysis"
        @click="goToBotAnalysis"
        class="d-flex pointer pl-2"
      >
        <img alt="" class="mr-2" src="@/assets/img/newkanban/botanalysis.svg" />
        <div class="fdbk-his-link">View Bot Analysis</div>
      </div>
      <div class="d-flex pr-2">
        <b-button class="acs-cancelBtn-modal w-105px mr-3" @click="closeModal"
          >Close</b-button
        >
      </div>
    </div>
  </b-modal>
</template>
<script>
import interviewProcessMixins from "./interviewProcessMixins";
import { downloadFeedback } from "../../utils/download.js";
import { mapGetters } from "vuex";

export default {
  name: "PreviewFeedback",
  mixins: [interviewProcessMixins],
  props: {
    selectedRound: Object,
    basicCandInfo: Object,
    allData: Object,
    ipmodal: Boolean,
    fromHistory: Boolean,
    candidateData: Object,
    showScreenshot: Boolean,
  },
  computed: {
    ...mapGetters("userVUEX", {
      projectUsers: "getProjectUsers",
      thirdPartyData: "getThirdPartyData",
    }),
    ...mapGetters(["roles"]),
    showCheatingText() {
      if (
        this.allData.assessmentResponse &&
        (this.allData.assessmentResponse.jobMaxCheatingPercentage ||
          this.allData.assessmentResponse.jobMaxCheatingPercentage == 0)
      )
        return true;
      return false;
    },
    getCheatingText() {
      let text =
        this.cheatingProbability <
        this.allData.assessmentResponse.jobMaxCheatingPercentage
          ? "Low Percentage"
          : "High Percentage";
      return text;
    },
    cheatingProbability() {
      if (
        this.allData.assessmentResponse &&
        Object.keys(this.allData.assessmentResponse).includes(
          "cheatingProbability"
        ) &&
        typeof this.allData.assessmentResponse.cheatingProbability == "number"
      )
        return this.allData.assessmentResponse.cheatingProbability;
      return null;
    },
    showBotAnalysis() {
      //  (this.$route.name == 'TalentPool' ||
      //   this.$route.name == 'Kanban') &&
      return (
        !this.fromHistory &&
        this.$route.name != "BotAnalysis" &&
        this.roles.includes("VIEW_CANDIDATE_ANALYSIS") &&
        this.allData.botInfo?.botAnalysisCompleted
      );
    },
    filledByHire3xPanel() {
      return this.allData.feedBackForm.processedBy?.startsWith("cand_panel");
    },
    showRecOptions() {
      if (this.thirdPartyData.configuration?.feedbackTypeID == "FEEDBACK2")
        return true;
      return false;
    },
    evaluationDate() {
      if (!this.basicCandInfo.evalDate) return "-";
      let formattedDate = this.basicCandInfo.evalDate
        .slice(0, 10)
        .split("-")
        .reverse()
        .join("-");
      return formattedDate.replaceAll("/", "-");
    },
    candidateAction() {
      if (this.showRecOptions && this.allData.feedBackForm.feedbackText) {
        return this.allData.feedBackForm.feedbackText;
      } else if (
        this.allData.feedBackForm.recommendation == "S" ||
        this.allData.feedBackForm.recommendation == "F"
      ) {
        return "Selected";
      } else if (this.allData.feedBackForm.recommendation == "R") {
        return "Rejected";
      } else if (this.allData.feedBackForm.recommendation == "NI") {
        return "Not Interested";
      } else if (this.allData.feedBackForm.recommendation == "DNA") {
        return "No Show";
      } else if (this.allData.feedBackForm.recommendation == "H") {
        return "On Hold";
      }
      return "";
    },
    modeOfInteriew() {
      return this.basicCandInfo.modeOfInterview == "f2f"
        ? "Face to Face"
        : "Assessment";
    },
    fileName() {
      let url = this.allData.feedBackForm.panelFeedbackForm;
      var urlWithoutParams = url.split("?")[0];

      // Split the remaining URL by '/' and get the last part
      var parts = urlWithoutParams.split("/");
      var lastSegment = parts.pop() || parts.pop(); // Handle potential trailing slash

      // Decode the URI component and return
      return decodeURIComponent(lastSegment);
    },
    feedbackByRec() {
      return (
        this.allData.feedBackForm.processedBy != "Panel" &&
        this.allData.feedBackForm.processedBy?.startsWith("rec_")
      );
    },
    userType() {
      let id = this.allData.feedBackForm.processedBy?.split("rec_")[1];
      if (this.projectUsers[id].roleName == "Vendor") return "Vendor";
      else return "Recruiter";
    },
    recruiterName() {
      let id = this.allData.feedBackForm.processedBy?.split("rec_")[1];
      return this.projectUsers[id].username?.replace(/\b\w/g, (char) =>
        char.toUpperCase()
      );
    },
  },
  methods: {
    getColor(type) {
      let value;
      if (
        this.allData.assessmentResponse.jobMaxCheatingPercentage ||
        this.allData.assessmentResponse.jobMaxCheatingPercentage == 0
      ) {
        if (
          this.cheatingProbability <
          this.allData.assessmentResponse.jobMaxCheatingPercentage
        )
          value = type == "color" ? "color-green" : "bg-green color-green";
        else
          value =
            type == "color" ? "color-darkred" : "bg-darkred color-darkred";
      } else {
        value = type == "color" ? "color-mainblue" : "bg-blue color-mainblue";
      }
      return value;
    },
    goToBotAnalysis() {
      let queryData = {
        intid: this.allData.interviewID,
        type: 1,
        history: true,
        candidateID: this.candidateData.candidateID,
        round: this.candidateData.kanbanLevel,
        fromPage: this.$route.name,
      };
      if (this.$route.name == "Kanban") queryData.fromkanban = true;
      if (this.$route.name == "TalentPool") queryData.frompool = true;
      queryData = {
        ...queryData,
        ...this.$route.query,
      };
      delete queryData.preview;
      this.$emit("storeCandidateData");
      this.$router.push({
        name: "BotAnalysis",
        query: queryData,
      });
    },
    closeModal() {
      this.$emit("closeModal");
      if (this.$route.query.history) {
        this.$store.commit("jobDescriptionVUEX/setSelectedCandidate", "");
      }
    },
    downloadFeedback(url) {
      downloadFeedback(url);
    },
  },
};
</script>
<style>
.download-bckg {
  background: #f6f6f6;
  border-radius: 8px;
}
</style>
